import { gql } from "@apollo/client";

const CurrentUserSubscription = gql`
  subscription UserSubscription($topic: String!) {
    listen(topic: $topic) {
      query {
        currentUser {
          appId
          email
          firstName
          lastName
          changePassword
          isActive
          isAdmin
          isExternal
          joinedOn
        }
      }
    }
  }
`;

const hash = "97c72e94924fa78a666b18fce2a0ebf08bfd07ffb1c8cb3bb0a480a941ef09ab";

export { CurrentUserSubscription, hash };
